
var dispatcher = require("../dispatcher");
var axios = require('axios');
var constants = require("../constants/constants");
var EventEmitter = require('events').EventEmitter;
var em = new EventEmitter();


function TransInformationStore() {
    var tempSession = {};

    function onChange(listener) {
        listener.push(listener);
    }

    function addListener(eventName, callback) {
        em.addListener(eventName, callback);
    }

    function removeListener(eventName, callback) {
        em.removeListener(eventName, callback);
    }

    function getotpDetails() {
        return tempSession;
    }

        function GoOtp(otp) {
            axios.post(constants.config.HOST + constants.api.POST_USER_MOBILE_OTP, {
                Mobile: otp.Mobile,
            }).then(function (response) {
                tempSession = (response.data);
              sessionStorage.setItem("User", JSON.stringify(tempSession));
                em.emit('getOTPInfo');
                console.log(JSON.parse(sessionStorage.getItem("User")));
            }).catch(function (error) {
                console.log(error);
            });
        }

        function SubmitOTP(Verifiedotp) {
            //var user = JSON.parse(sessionStorage.getItem("User"));
            axios.post(constants.config.HOST + constants.api.POST_USER_MOBILE_OTP_VERIFIED, {
                OTP: Verifiedotp.OTP,
                Mobile: JSON.parse(sessionStorage.getItem("User")).Mobile,
            }).then(function (response) {
                tempSession = (response.data);
                if (response.data.Type === 'success') {
                  console.log({ tempSession: response.data });
                    sessionStorage.setItem("User", JSON.stringify(tempSession));
                    console.log('OTP verified successfully');
                    console.log(JSON.parse(sessionStorage.getItem("User")));
                }
                else if (response.data.Type === 'error') {
                    console.log('OTP verification failed');
                }
                em.emit('getVerifyOTPInfo');
            }).catch(function (error) {
                console.log(error);
            });
        }

        dispatcher.register(function (payload) {
            var split = payload.type.split(":");
            if (split[0] === "transport") {
                switch (split[1]) {
                    case "GoOtp":
                        GoOtp(payload.otp);
                        break;
                    case "SubmitOTP":
                        SubmitOTP(payload.Verifiedotp);
                     break;
                }
            }

        });
        return {
            onChange: onChange,
            addListener: addListener,
            removeListener: removeListener,
            getotpDetails: getotpDetails,

        }
    }
    module.exports = TransInformationStore();




// WEBPACK FOOTER //
// ./src/stores/TransInformationStore.js